import React, { Component } from 'react';
import logo from '../../assets/AHTT_logo.gif';
import Popup from '../other/Popup';
import Logo from './Logo';

class Landing extends Component {
    render() {
        const randomIndex = Math.round(Math.random() * 2);
        const w = window.innerWidth;

        const upcomingPositions = [{
            x: w - Math.max(w * 0.33, 500),
            y: window.innerHeight - 400 - 200 // window width - popup width - distance from right
        }, {
            x: 168,
            y: 143
        }, {
            x: 45,
            y: 45
        }];
        const signupPositions = [{
            x: 60,
            y: 40
        }, {
            x: 168 + 400 + 20,
            y: 143
        }, {
            x: w - 240 - 118, // window width - popup width - distance from right
            y: 445
        }];
        const upcomingPos = upcomingPositions[randomIndex];
        const signupPos = signupPositions[randomIndex];
        const widths = [102, 92, 93, 160, 102, 91, 101, 170]; // letter widths
        const logoPositions = [
            [
                // default position in Logo component
            ],
            [
                // window width - letter width - distance from right
                [(w - widths[0] - 345), (427)], // a
                [(w - widths[1] - 360), (317)], // n
                [(w - widths[2] - 401), (373)], // y
                [(w - widths[3] - 474), (312)], // w
                [(w - widths[4] - 440), (540)], // a
                [(w - widths[5] - 443), (427)], // y
                [(w - widths[6] - 375), (510)], // s
                [(w - widths[7] - 180), (317)] // here
            ],
            [
                [(w - widths[0] - 130), (325)], // a
                [(52), (363)], // n
                [(w - widths[2] - 575), (344)], // y
                [(w - widths[3] - 432), (559)], // w
                [(w - widths[4] - 370), (40)], // a
                [(w - widths[5] - 525), (228)], // y
                [(460), (220)], // s
                [(175), (363)] // here
            ]
        ];

        return (
            <div id="landing">
              <p>
                <img src={logo} className="landing-logo" alt="logo" /><br/>
                {this.props.intro}
              </p>
              <Logo pos={logoPositions[randomIndex]}/>
              {this.props.event !== undefined &&
                <Popup containerId="upcoming" desktopPos={upcomingPos} event={this.props.event} activeHor={this.props.pastOrFuture} activeVer={this.props.event.eventOrExhibition[0]}/>
              }
              <Popup containerId="signup" desktopPos={signupPos} />
            </div>
        );
    }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js